import React from 'react';
import { Box } from '@mui/material';
import Navbar from './Navbar';
import HeroSection from './HeroSection';
import FeatureHighlights from './FeatureHighlights';
import TrustedBy from './TrustedBy';
import ServiceCategories from './ServiceCategories';
import WhyChooseUs from './WhyChooseUs';
import FounderSection from './FounderSection';
import Testimonials from './Testimonials';
import FAQSection from './FAQSection';
import MobileAppSection from './MobileAppSection';
import Footer from './Footer';
import SEO from '../SEO/SEO';
import { faqs } from './content';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map(({ question, answer }) => ({
    '@type': 'Question',
    name: question,
    acceptedAnswer: { '@type': 'Answer', text: answer },
  })),
};

const LandingPage = () => (
  <Box sx={{ bgcolor: 'background.default', color: 'text.primary' }}>
    <SEO
      title="Remembr, Track Bills, Services & Maintenance in One Dashboard"
      description="The smart, free, cloud-based diary for bills, service history and maintenance reminders, built by Arrayscript."
      path="/"
      schema={faqSchema}
    />
    <Navbar />
    <HeroSection />
    <FeatureHighlights />
    <TrustedBy />
    <ServiceCategories />
    <WhyChooseUs />
    <FounderSection />
    <Testimonials />
    <MobileAppSection />
    <FAQSection />
    <Footer />
  </Box>
);

export default LandingPage;
